import { render, staticRenderFns } from "./SourcesGoalChart.vue?vue&type=template&id=59651cf4&scoped=true&"
import script from "./SourcesGoalChart.vue?vue&type=script&lang=js&"
export * from "./SourcesGoalChart.vue?vue&type=script&lang=js&"
import style0 from "./SourcesGoalChart.vue?vue&type=style&index=0&id=59651cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59651cf4",
  null
  
)

export default component.exports